export * from './lib/credit';
export * from './lib/objective';
export * from './lib/faq';
export * from './lib/quizmaker';
export * from './lib/difficulty';
export * from './lib/materials';
export * from './lib/time';
export * from './lib/activities';
export * from './lib/subjectExtension';
export * from './lib/analogy';
export * from './lib/dailyLessonLog';
export * from './lib/catchUpFridays';
export * from './lib/summativeTest';
export * from './lib/cerebroLessonPlan';
export * from './lib/cerebroFormat';
export * from './lib/features';
export * from './lib/withRetry';
export * from './lib/prompts';
export * from './lib/dllFormat';
export * from './lib/topicExplorer';
export * from './lib/energizer';
export * from './lib/elif';
export * from './lib/unitPlan';
export * from './lib/genericUnpacking';
export * from './lib/pptMaker';
export * from './lib/modality';
export * from './lib/tutorial';
export * from './lib/lessonPlan';
export enum GPT_PROVIDER {
  SYMPH = 'SYMPH',
  OPENAI = 'OPENAI',
}

export enum FeatureType {
  LESSON_PLANNER = 'LESSON_PLANNER',
  CATCH_UP_FRIDAYS = 'CATCH_UP_FRIDAYS',
  GENERIC_UNPACKING = 'GENERIC_UNPACKING',
  SUMMATIVE_TEST = 'SUMMATIVE_TEST',
  ACTIVITY = 'ACTIVITY',
  SHORT_QUIZ = 'SHORT_QUIZ',
  DLL = 'DLL',
  DLL_CONTINUATION = 'DLL_CONTINUATION',
  OBJECTIVES = 'OBJECTIVES',
  ANALOGY = 'ANALOGY',
  LWAC = 'LWAC',
  TOPIC_EXPLORER = 'TOPIC_EXPLORER',
  ENERGIZER = 'ENERGIZER',
  ELIF = 'ELIF',
  UNIT_PLAN = 'UNIT_PLAN',
  PPT_MAKER = 'PPT_MAKER',
  MULTIGRADE_LESSON_PLAN = 'MULTIGRADE_LESSON_PLAN',
  IPLAN_OBJECTIVES = 'IPLAN_OBJECTIVES',
  CEREBRO_LESSON_PLAN = 'CEREBRO_LESSON_PLAN',
}

export const CACHEBLE_FEATURES = [
  FeatureType.LESSON_PLANNER,
  FeatureType.CATCH_UP_FRIDAYS,
  FeatureType.GENERIC_UNPACKING,
  FeatureType.SUMMATIVE_TEST,
  FeatureType.ACTIVITY,
  FeatureType.SHORT_QUIZ,
  FeatureType.DLL,
  FeatureType.DLL_CONTINUATION,
  FeatureType.OBJECTIVES,
  FeatureType.ANALOGY,
  FeatureType.LWAC,
  FeatureType.TOPIC_EXPLORER,
  FeatureType.ENERGIZER,
  FeatureType.ELIF,
  FeatureType.UNIT_PLAN,
  FeatureType.PPT_MAKER,
  FeatureType.MULTIGRADE_LESSON_PLAN,
  FeatureType.IPLAN_OBJECTIVES,
  FeatureType.CEREBRO_LESSON_PLAN,
];
